<template>
  <base-panel
    v-for="i in 3"
    :key="i"
    no-margin
    full-width
    :no-padding="purchasePage"
    :class="{
      'tw-w-full': purchasePage,
    }"
  >
    <div
      :class="{
        'tw-w-full tw-flex tw-items-center tw-justify-between tw-p-6 game-tile-background-color game-tile-radius':
          purchasePage,
        'tw-space-y-4': !purchasePage,
      }"
    >
      <template v-if="admin">
        <loading-title random />
        <div
          class="tw-animate-pulse tw-bg-theme-1 tw-rounded-full tw-w-30 tw-h-4"
        />
        <loading-title random />
        <div class="tw-flex tw-space-x-4 tw-items-center">
          <base-toggle input-loading />
          <loading-label />
        </div>
        <div class="tw-flex tw-w-full tw-space-x-2">
          <loading-button full-width class="tw-flex-1" />
          <loading-button input-btn />
        </div>
      </template>
      <template v-else-if="!purchasePage">
        <div class="tw-flex tw-space-x-4 tw-items-center">
          <base-toggle input-loading />
          <loading-title random />
        </div>
        <loading-input />
        <div class="tw-flex tw-space-x-4">
          <loading-title random />
          <loading-title random />
        </div>
        <div class="tw-space-y-2">
          <loading-input type="textarea" rows="2" />
          <loading-input />
        </div>
      </template>
      <template v-else>
        <loading-title />
        <loading-button />
      </template>
    </div>
  </base-panel>
</template>

<script>
import LoadingButton from '@components/Loading/LoadingButton.vue'
import LoadingTitle from '@components/Loading/LoadingTitle.vue'
import LoadingLabel from '@components/Loading/LoadingLabel.vue'
import LoadingInput from '@components/Loading/LoadingInput.vue'

export default {
  components: {
    LoadingButton,
    LoadingTitle,
    LoadingLabel,
    LoadingInput,
  },
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
    purchasePage: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
